export const DARK_MODE_STORAGE_KEY = 'darkMode'
export const DARK_MODE_CLASS = 'dark-mode'
export const DARK_MODE_CHANGE_EVENT = 'p3portal-dark-mode'

let shortcutBound = false

export function isDarkModeEnabled() {
  try {
    return window.localStorage.getItem(DARK_MODE_STORAGE_KEY) === 'true'
  } catch (e) {
    return false
  }
}

export function applyDarkModeClass(enabled) {
  document.documentElement.classList.toggle(DARK_MODE_CLASS, !!enabled)
}

export function setDarkModeEnabled(enabled) {
  const nextEnabled = !!enabled
  try {
    if (nextEnabled) {
      window.localStorage.setItem(DARK_MODE_STORAGE_KEY, 'true')
    } else {
      window.localStorage.removeItem(DARK_MODE_STORAGE_KEY)
    }
  } catch (e) {
    // Ignore quota / private-mode failures; still apply the class for this session.
  }
  applyDarkModeClass(nextEnabled)
  window.dispatchEvent(new CustomEvent(DARK_MODE_CHANGE_EVENT, { detail: { enabled: nextEnabled } }))
}

export function toggleDarkMode() {
  setDarkModeEnabled(!isDarkModeEnabled())
}

export function applyDarkModeFromStorage() {
  applyDarkModeClass(isDarkModeEnabled())
}

function isDarkModeShortcut(event) {
  return event.ctrlKey && event.shiftKey && !event.altKey && !event.metaKey && event.code === 'KeyD'
}

function onDarkModeShortcut(event) {
  if (event.repeat || !isDarkModeShortcut(event)) return
  event.preventDefault()
  toggleDarkMode()
}

export function bindDarkModeShortcut() {
  if (shortcutBound || typeof window === 'undefined') return
  shortcutBound = true
  window.addEventListener('keydown', onDarkModeShortcut, true)
}
